import React from "react";
import DesignUtils from "../../utils/DesignUtils";
import AppConstants from "../../constants/AppConstants";
import UserService from "../../service/UserService";
import { getUserId } from "../../hooks/query/useAccount";
import { queryClient } from "../../utils/QueryUtils.js";
import { USER_LIBRARY_DESIGNS } from "../../constants/QueryKeys.js";
import LibrarySitePreview from "../LibrarySitePreview.jsx";

const ImportPreview = ({ designExport, setAddDesignState }) => {
  const designURL = DesignUtils.getPreviewURL(designExport.pub_key);
  const { designTitle, designDesc } = designExport;
  const _importComplete = async () => {
    await queryClient.refetchQueries({ queryKey: [USER_LIBRARY_DESIGNS] });
    setAddDesignState(AppConstants.IMPORT_DESIGN_COMPLETED);
  };
  const onImportDesign = () => {
    setAddDesignState(AppConstants.IMPORT_DESIGN_LOADING);
    UserService.addLibraryDesign(getUserId(), designExport.export_id)
      .then(_importComplete)
      .catch((err) => setAddDesignState(err));
  };
  return (
    <div className="import-preview">
      <LibrarySitePreview
        modal="import"
        buttonText="Start with this design"
        designURL={designURL}
        designTitle={designTitle}
        designDesc={designDesc}
        onSelect={onImportDesign}
      />
    </div>
  );
};

export default ImportPreview;
